import { render, staticRenderFns } from "./CompanyOverviewSection.vue?vue&type=template&id=626723dc"
import script from "./CompanyOverviewSection.vue?vue&type=script&lang=js"
export * from "./CompanyOverviewSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports